<template>
  <div class="lounge-page">
    <div :class="['lounge-header', { 'lounge-header-active': customBanner }]">
      <template v-if="!customBanner">
        <img v-if="bannerImg" class="lounge-img-mask" :src="bannerImg" />
      </template>
      <div class="lounge-img-box" v-else>
        <p>
          {{ $t('customer-banner-desc') }}
        </p>
        <button @click="jumpURL()">{{ $t('view-details') }}</button>
        <img
          v-if="currCustomerBanner"
          class="lounge-img-mask"
          :src="currCustomerBanner.pic"
          alt="banner"
        />
      </div>
      <!-- 从search bar跳转过来 -->
      <div v-if="this.fromSearchData.countryid" class="lounge-countrys">
        <p class="airport-name">
          {{ this.fromSearchData.name }}
          <span>({{ this.fromSearchData.iataCode }})</span>
        </p>
        <div class="airport-line"></div>
        <span class="airport-city">{{ this.fromSearchData.cityName }},</span>
        <span class="airport-country">&nbsp;{{ this.fromSearchData.countryName }}</span>
      </div>

      <!-- 点击头部lounge/benefits跳转过来 -->
      <div v-else>
        <p class="lounge-header-title">{{ $t('views-lounge-discover') }}</p>
        <search
          :placeholder="$t('search-airport')"
          :listData="searchLish"
          @searchClick="handleSearchClick"
          class="lounge-search"
        >
        </search>
      </div>
    </div>

    <!-- 移动端模块 -->
    <div class="lounge-header-mobile">
      <template v-if="!customBanner">
        <img v-if="bannerImg" class="lounge-img-mask" :src="bannerImg" />
      </template>
      <div class="lounge-img-box" v-else>
        <p>
          {{ $t('customer-banner-desc') }}
        </p>
        <button @click="jumpURL()">{{ $t('view-details') }}</button>
        <img
          v-if="currCustomerBanner"
          class="lounge-img-mask"
          :src="currCustomerBanner.pic"
          alt="banner"
        />
      </div>

      <!-- 从search bar跳转过来 -->
      <div v-if="this.fromSearchData.countryid" class="lounge-countrys">
        <p class="airport-name">
          {{ this.fromSearchData.name }}
          <span>({{ this.fromSearchData.iataCode }})</span>
        </p>
        <div class="airport-line"></div>
        <p class="airport-ctname">
          <span class="airport-city">{{ this.fromSearchData.cityName }},</span>
          <span class="airport-country">&nbsp;{{ this.fromSearchData.countryName }}</span>
        </p>
      </div>

      <!-- 点击头部lounge/benefits跳转过来 -->
      <div v-else>
        <p class="lounge-header-title">{{ $t('views-lounge-discover') }}</p>
        <search
          :placeholder="$t('search-airport')"
          :listData="searchLish"
          @searchClick="handleSearchClick"
          class="lounge-search"
        >
        </search>
      </div>
    </div>

    <!-- 内容部分 -->
    <div class="content">
      <!-- lounge组件 -->
      <template v-if="currentComponent === 'FormLounge'">
        <form-lounge v-bind="loungeNeedShowData"></form-lounge>
      </template>

      <!-- benefits组件 -->
      <template v-else-if="currentComponent === 'FormBenefits'">
        <form-benefits v-bind="loungeNeedShowData"></form-benefits>
      </template>

      <!-- search组件 -->
      <template v-else-if="currentComponent === 'FormSearch'">
        <form-search
          :fromSearchData="fromSearchData"
          v-bind="searchNeedShowData"
          ref="fromSearchComponent"
          @handleApplyFilter="handleApplyFilter"
          @changeTab="handleChangeTab"
        >
        </form-search>
      </template>
    </div>
  </div>
</template>

<script>
  import Search from '@/components/BaseUi/Search';
  import FormLounge from './component/fromLounge';
  import FormBenefits from './component/fromBenefits';
  import FormSearch from './component/fromSearch';
  import { mapMutations, mapState } from 'vuex';

  const customerBanner = [
    // {
    //   iataCode: 'YVR',
    //   pic: require('@/assets/images/vancouver.png'),
    //   // link: 'https://www.visainfinite.ca/privilege/en/home.html?category=travelLink&offerId=117029',
    //   link: '/benefit/details?vmorcId=117029',
    // },
    {
      iataCode: 'YOW',
      pic: require('@/assets/images/ottawa.png'),
      // link: 'https://www.visainfinite.ca/privilege/en/home.html?category=travelLink&offerId=117015',
      link: '/benefit/details?vmorcId=117015',
    },
    {
      iataCode: 'YUL',
      pic: require('@/assets/images/montreal.png'),
      // link: 'https://www.visainfinite.ca/privilege/en/home.html?category=travelLink&offerId=117012',
      link: '/benefit/details?vmorcId=117012',
    },
  ];
  export default {
    components: {
      Search,
      FormLounge,
      FormBenefits,
      FormSearch,
    },
    watch: {
      $route: {
        handler(to) {
          if ('airport' in to.query) {
            this.getSearch();
            this.getCustomShowBanner();
            return;
          }
          this.customBanner = false;
          this.getFrom(to);
        },
      },
      isLogin: {
        handler() {
          this.getAirport();
        },
        immediate: false,
      },
    },

    async mounted() {
      await this.getAirport();
      if ('airport' in this.$route.query) {
        this.getSearch();
        this.getCustomShowBanner();
        return;
      }
      this.getFrom(this.$route);
    },
    data() {
      return {
        tabBarList: [
          {
            title: 'lounge',
            type: 'lounges',
          },
          {
            title: 'search-dining',
            type: 'dining',
          },
          {
            title: 'search-retail',
            type: 'retail',
          },
        ],
        // 直接跳转url到达search lounge时的机场id
        sid: '',
        searchLish: [],
        fromSearchData: {},
        currentComponent: 'FormLounge',
        bannerImg: '',
        customBanner: false,
        // lounge应该展示的数据
        loungeNeedShowData: {
          title: 'views-lounge-title1',
          loungeData: {
            showDesc2: true,
            cardHeadStyle: {
              display: 'none',
            },
            cardItemStyle: {
              width: '25%',
              marginBottom: '30px',
            },
            cards: [],
            type: this.$route.params,
          },
        },

        // search页应该展示的数据
        searchNeedShowData: {
          loadingStatus: [true, true],
          loungeLength: 0,
          firstLoungeLength: 0,
          diningLength: 0,
          firstDiningLength: 0,
          retailLength: 0,
          searchItemData: {
            showDiscount: false,
            showDesc2: true,
            cardHeadStyle: {
              display: 'none',
            },
            cardItemStyle: {
              width: '25%',
              // marginBottom: '45px',
            },
            cards: [],
            type: 1,
            airportCode: null,
          },
        },

        orginalData: {
          loungeData: [],
          diningData: [],
          retailData: [],
        },
      };
    },
    computed: {
      currCustomerBanner() {
        return customerBanner.find(_ => _.iataCode === this.fromSearchData.iataCode);
      },

      ...mapState(['searchItem', 'userInfo', 'airportServiceCategoryIndex']),
    },
    methods: {
      jumpURL() {
        // window.open(this.currCustomerBanner.link);
        this.$router.push(this.currCustomerBanner.link);
      },
      getCustomShowBanner() {
        const userId = this.userInfo?.userId;
        if (this.currCustomerBanner && userId) {
          this.fetchCustomShowBanner(userId);
        } else {
          this.customBanner = false;
        }
      },

      fetchCustomShowBanner(userId) {
        this.$http.lounge
          .customShowBanner({ userId })
          .then(res => {
            if (res.state === '11') {
              this.customBanner = res.show;
            }
          })
          .catch(e => {
            console.log(e, 'customShowBanner');
          });
      },
      getType() {
        if (this.currentComponent === 'FormLounge') {
          const { userInfo } = this.$store.state;
          const { airportCode } = this.fromSearchData;
          const lang = this.$i18n.locale;
          const data = {
            lang,
            userId: userInfo?.userId,
            airportCode,
            condition: {},
          };
          this.$http.lounge
            .getRetailList(data)
            .then(res => {
              if (res.state === '11') {
                this.loungeNeedShowData.loungeData.cards = res?.list || [];
              } else {
                console.error(res.note);
              }
            })
            .catch(() => {
              this.$messageModal.issueApi(this.getType);
            });
        }
      },
      // 获取机场数据
      async getAirport() {
        const { userId, sessionId } = this.userInfo || {};
        const params = {
          lang: this.$i18n.locale,
          userId,
          sessionId,
        };
        const res = await this.$http.common.findAllAirport(params);
        if (res?.state === '11') {
          this.searchLish = Object.freeze(res.data);
        } else {
          res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
        }
        // 通过url直接跳转
        if (!this.searchItem) {
          this.sid = this.searchLish.find(item => {
            return item.name === this.$route.query.airport;
          });
        }
      },

      // 获取搜索选项的值
      getSearch() {
        // 需求：
        let searchItemInfo = JSON.parse(sessionStorage.getItem('searchItem')) || this.sid;
        if (searchItemInfo.lang !== this.$i18n.locale) {
          // 如果语言不一致，则需要重新获取对应语言的机场详情
          searchItemInfo =
            this.searchLish.find(item => {
              return item.airportCode === searchItemInfo.airportCode;
            }) || searchItemInfo;
          sessionStorage.setItem('searchItem', JSON.stringify(searchItemInfo));
        }
        this.getFrom({ name: 'Search' }, searchItemInfo);
      },

      // 判断当前是从哪里过来的
      getFrom(query, searchItemInfo = {}) {
        if (!searchItemInfo?.countryid) {
          // 该判断用于判断是否展示搜索框
          this.fromSearchData = {};
        }
        switch (query.name) {
          case 'Benefits':
            this.currentComponent = 'FormBenefits';
            this.loungeNeedShowData.loungeData.type = 4;
            this.bannerImg = require('img/lounge-img.png');
            break;
          case 'Lounges':
            this.getLoungeDatas('lounge');
            this.loungeNeedShowData.loungeData.type = 1;
            this.bannerImg = require('img/lounge-img.png');
            break;
          case 'Dining':
            this.getLoungeDatas('dining');
            this.loungeNeedShowData.loungeData.type = 2;
            this.bannerImg = require('img/dining-banner.png');
            break;
          case 'Retail':
            this.getLoungeDatas('retail');
            this.loungeNeedShowData.loungeData.type = 3;
            this.bannerImg = require('img/retail-banner.png');
            break;
          case 'Search':
            // 通过search选项点击后跳转到lounges
            this.currentComponent = 'FormSearch';
            this.fromSearchData = searchItemInfo;
            this.getCardList({
              scode: searchItemInfo.airportCode,
              lang: this.$i18n.locale,
              type: this.airportServiceCategoryIndex + 1,
              userId: this.$store.state.userInfo?.userId || '',
            });
            this.$nextTick(() => {
              const { fromSearchComponent } = this.$refs;
              fromSearchComponent.handleResetFilter();
              fromSearchComponent.handleGetFilterData(searchItemInfo);
              fromSearchComponent.handleClickItem(this.airportServiceCategoryIndex, {
                title: this.tabBarList[this.airportServiceCategoryIndex].title,
                type: this.tabBarList[this.airportServiceCategoryIndex].type,
              });
            });
            this.bannerImg = require('img/lounge-img.png');
            break;
        }
      },

      // 从home和bennefits通过view more跳转过来, 获取对应的lounge应该展示的数据
      getLoungeDatas(data) {
        this.currentComponent = 'FormLounge';
        switch (data) {
          case 'dining':
            this.loungeNeedShowData.title = 'views-lounge-title2';
            this.getLoungeList(2);
            break;
          case 'retail':
            this.loungeNeedShowData.title = 'views-lounge-title3';
            this.getLoungeList(3);
            break;
          default:
            this.loungeNeedShowData.title = 'views-lounge-title1';
            this.getLoungeList(1);
            break;
        }
      },

      // 获取lounge页面数据
      getLoungeList(type) {
        this.$loading.show();
        const data = {
          type,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
        };
        this.$http.lounge.getLoungeList(data).then(
          res => {
            if (res.state === '11') {
              this.loungeNeedShowData.loungeData.cards = res.payload;
              this.setFakeElement(this.loungeNeedShowData.loungeData.cards);
              this.$loading.hide();
            } else {
              console.error(res.note);
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // searchBox搜索后点击item跳转
      handleSearchClick(data) {
        sessionStorage.setItem('searchItem', JSON.stringify(data));
        this.$router.push({
          path: '/lounges',
          query: { airport: data.name, type: data.type },
        });
      },

      handleChangeTab(type) {
        this.searchNeedShowData.searchItemData.showDiscount = false;
        this.searchNeedShowData.searchItemData.showDesc2 = true;
        this.searchNeedShowData.searchItemData.type = type;
        if (type === 1) {
          this.searchNeedShowData.searchItemData.cards = this.orginalData.loungeData || [];
          // this.searchNeedShowData.loungeLength = this.orginalData.loungeData.length;
        } else if (type === 2) {
          this.searchNeedShowData.searchItemData.cards = this.orginalData.diningData || [];
          // this.searchNeedShowData.diningLength = this.orginalData.diningData.length;
        } else {
          this.searchNeedShowData.searchItemData.cards = this.orginalData.retailData || [];
          // this.searchNeedShowData.retailLength = this.orginalData.retailData.length;
        }
        this.setFakeElement(this.searchNeedShowData.searchItemData.cards);
      },

      // 获取search页面数据
      // 过滤filter数据后,获取机场休息室列表和餐厅列表
      getCardList(data) {
        this.searchNeedShowData.loadingStatus[0] = true;
        this.$loading.show();
        this.$http.lounge.getCardList(data).then(
          res => {
            // 需求：search机场时，loading时隐藏no item found, 此时有两个接口，另外一个在fromSearch，配合一个数组以确认loading结束的状态
            this.searchNeedShowData.loadingStatus[0] = false;
            if (res && res.state === '11') {
              this.orginalData.loungeData = res.payload[0]?.list || [];
              this.searchNeedShowData.loungeLength = res.payload[0]?.list?.length || 0;
              this.orginalData.diningData = res.payload[1]?.list || [];
              this.searchNeedShowData.diningLength = res.payload[1]?.list?.length || 0;
              this.orginalData.retailData = res.payload[2]?.list || [];
              this.searchNeedShowData.retailLength = res.payload[2]?.list?.length || 0;
              this.handleChangeTab(data.type);
              this.$loading.hide();
            } else {
              this.searchNeedShowData.searchItemData.cards = [];
              console.error(res.note);
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // search页面Filter点击过滤事件
      handleApplyFilter(cdt = {}, type = 1) {
        const { userInfo } = this.$store.state;
        const { airportCode } = this.fromSearchData;
        // 新接口需要判断所有的选项中如果带 All , 则移除当前的选项
        const condition = Object.keys(cdt).reduce((obj, key) => {
          if (key === 'bookableList') {
            obj[key] = cdt[key];
          } else {
            // 过滤掉带All的选项
            const allStrIndex = cdt[key].findIndex(str => str.indexOf('All') === 0);
            if (allStrIndex !== -1) {
              obj[key] = undefined;
            } else {
              obj[key] = cdt[key];
            }
          }
          return obj;
        }, {});
        const filterData = {
          // airportCode,
          scode: airportCode,
          lang: this.$i18n.locale,
          userId: userInfo?.userId || '',
          ...condition,
          type,
        };

        this.getCardList(filterData);
      },

      // 获取Retail list的数据
      getRetailList() {
        this.searchNeedShowData.loadingStatus[0] = true;
        this.$loading.show();
        const { userInfo } = this.$store.state;
        const { airportCode } = this.fromSearchData;
        const lang = this.$i18n.locale;
        const data = {
          lang,
          userId: userInfo?.userId,
          airportCode,
          condition: {},
        };
        this.$http.lounge
          .getRetailList(data)
          .then(res => {
            this.searchNeedShowData.loadingStatus[0] = false;
            if (res.state === '11') {
              this.searchNeedShowData.retailLength = res?.list?.length || 0;
              this.searchNeedShowData.searchItemData.cards = res?.list || [];
              this.searchNeedShowData.searchItemData.showDiscount = false;
              this.searchNeedShowData.searchItemData.showDesc2 = true;
              // fromSearch子组件标识当前为零售店
              this.searchNeedShowData.searchItemData.type = 3;
              this.searchNeedShowData.searchItemData.airportCode = res.list[0].airportCode;
              this.setFakeElement(this.searchNeedShowData.searchItemData.cards);
              this.$loading.hide();
            } else {
              console.error(res.note);
              this.$loading.hide();
            }
          })
          .catch(() => {
            this.$messageModal.issueApi(this.getRetailList);
          });
      },

      // TODO: 后面可以单独抽离出来
      setFakeElement(arr) {
        if (arr.length) {
          // 获取到最后一行剩下多少个元素，判断需要往里面添加多少个假元素
          const itemlist = arr;
          const remainItemLength = itemlist.length % 3;
          if (remainItemLength) {
            const needPushLength = 3 - remainItemLength;
            if (needPushLength) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < needPushLength; i++) {
                itemlist.push({ fakeElement: true });
              }
            }
          }
        }
      },

      ...mapMutations(['showMessageModal', 'isLogin']),
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
